import axios from 'axios';

// encryptionSession.js
// Uses a raw axios instance (NOT axiosInstance) to avoid circular dependency:
// axiosInstance response interceptor → initEncryptionSession → axiosInstance → infinite loop
const rawAxios = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://health.orangehealth.online/',
});

let AES_SESSION_KEY = null;
let RSA_PRIVATE_KEY = null;
let _sessionPromise = null; // promise lock to prevent concurrent fetches

export async function initEncryptionSession() {
  // Already have the key — return immediately
  if (AES_SESSION_KEY) return AES_SESSION_KEY;

  // A fetch is already in flight — wait for it instead of firing another
  if (_sessionPromise) return _sessionPromise;

  _sessionPromise = (async () => {
    try {
      const resp = await rawAxios.post('admin/create-session', { module: 'G' });
      const aesKey = atob(resp.data.aesKeyBase64);
      AES_SESSION_KEY = aesKey;
      return AES_SESSION_KEY;
    } catch (err) {
      console.error('initEncryptionSession failed:', err?.message);
      return null;
    } finally {
      _sessionPromise = null;
    }
  })();

  return _sessionPromise;
}

export function aesKeyToBase64(aesKeyUint8) {
  return btoa(String.fromCharCode(...aesKeyUint8));
}

// Call on logout to force re-fetch next session
export function clearEncryptionSession() {
  AES_SESSION_KEY = null;
  RSA_PRIVATE_KEY = null;
  _sessionPromise = null;
}
